// extracted by mini-css-extract-plugin
export var addedUser = "SmorgasbordUserListModule-module--addedUser--RIkT-";
export var addedUsersContainer = "SmorgasbordUserListModule-module--addedUsersContainer--LaxYe";
export var button = "SmorgasbordUserListModule-module--button--Vn89N";
export var list = "SmorgasbordUserListModule-module--list--Pz+YH";
export var ssn = "SmorgasbordUserListModule-module--ssn--6OR6M";
export var ssnInput = "SmorgasbordUserListModule-module--ssnInput--Zbgvg";
export var title = "SmorgasbordUserListModule-module--title--RoNPh";